module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('h1', [_vm._v("Vérifiez votre email")]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": _vm.emailIconUrl,
      "alt": "Vérifiez votre adresse email"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text-xs-justify"
  }, [_vm._v("\n      Merci de rejoindre Weview. Un email de confirmation vient de vous être envoyé, cliquez sur le lien dans cet email pour continuer le processus d'inscription.\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "text-xs-justify"
  }, [_vm._v("\n      Note : Cet email peut prendre quelques minutes à arriver dans votre boite de réception. En cas de non réception, merci de nous écrire sur "), _c('a', {
    attrs: {
      "href": "mailto:inscriptions@weview.fr"
    }
  }, [_vm._v("inscriptions@weview.fr")]), _vm._v(".\n    ")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-90f3aa90","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RegistrationSuccess.vue
// module id = 554
// module chunks = 1